import { render, staticRenderFns } from "./CoPaymentMethodCard.vue?vue&type=template&id=633d20cc&scoped=true&"
import script from "./CoPaymentMethodCard.vue?vue&type=script&lang=ts&"
export * from "./CoPaymentMethodCard.vue?vue&type=script&lang=ts&"
import style0 from "./CoPaymentMethodCard.vue?vue&type=style&index=0&id=633d20cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d20cc",
  null
  
)

export default component.exports